import styled from 'styled-components';
import { UncontrolledTooltip } from 'reactstrap';
import {
  fontSize,
  lineHeight,
  gray,
  mediaBreakpointUp,
  multiply,
  spacer,
  themeColor,
  getThemeProp,
  color,
  mediaBreakpointDown,
  boxShadow,
} from '@whitelabel/helpers/style';

export const StyledUncontrolledTooltip = styled(UncontrolledTooltip)`
  .tooltip {
    .tooltip-inner {
      max-width: inherit;
      padding: ${spacer};
      color: ${themeColor('header')};
      text-align: start;
      background: ${color('white')};
      border: ${getThemeProp('borderWidth')} solid ${gray(300)};
      box-shadow: ${boxShadow('md')};

      ${mediaBreakpointDown('xs')`
        margin: 0 ${multiply(spacer, 2)};
      `}
      ${mediaBreakpointUp('xs')`
        font-size: ${multiply(fontSize('base'), 1.125)};
        line-height: ${lineHeight('base')};
      `}
      ${mediaBreakpointUp('sm')`
        max-width: ${multiply(spacer, 25)};
      `}
      ${mediaBreakpointUp('lg')`
        font-size: ${fontSize('lg')};
        line-height: ${lineHeight('base')};
      `}

      p:last-child {
        margin: 0;
      }
    }

    &.show {
      opacity: 1;
    }
  }

  .tooltip.bs-tooltip-auto {
    &[x-placement^='top'] .arrow {
      bottom: ${multiply(spacer, 0.4)};

      &::before {
        border-top-color: ${color('white')};
      }
    }

    &[x-placement^='right'] .arrow {
      left: ${multiply(spacer, 0.4)};

      &::before {
        border-right-color: ${color('white')};
      }
    }

    &[x-placement^='bottom'] .arrow {
      top: ${multiply(spacer, 0.4)};

      &::before {
        border-bottom-color: ${color('white')};
      }
    }

    &[x-placement^='left'] .arrow {
      right: ${multiply(spacer, 0.4)};

      &::before {
        border-left-color: ${color('white')};
      }
    }
  }
`;

export default StyledUncontrolledTooltip;
